module.exports = "/fonts/opensans.ttf";